import { Mesh } from "../../../basePass";
import { GetVec2 } from "../../../core/types";

export class ParticleDesc {
    //Main
    MaxNumInstances = 100;
    ParticleLifeTimeSec = 5.0;
    NumParticlesPerSpawn = 3;
    SpawnTimeDelta = 1.0;

    //Spawn
    InitPosRandOffsetScale = 1.0;
    InitVelMin = 1.0;
    RandVelScale = 1.0;
    InitVelHeightBoost = 0.5;
    InitVelocityZScale = 1.0;
    CurlNoiseVelScale = 1.0;
    bInitVelocityDense = false;
    EmitterTextureSpawnRange = GetVec2(0.0, 1.0);
    bConstSpawnPos = false;
    bForceSpawn = false;

    //Const
    SizeScale = 1.0;
    SizeRandMinMax = GetVec2(0.2, 1.2);
    RandHeightSizeMinMax = GetVec2(1.0, 5.0);
    GravityForceScale = 1.0;
    ToCamWindForceScale = 0.0;
    bProceduralCube = false;
    RotationSpeedScale = 1.0;
    bUseCurlNoiseVelocity = false;
    bUseCurlNoiseVelocityLF = false;
    bMoreCurlOnImpact = true;
    VelocityDampingAdd = 0.0;
    bVelocityBasedRotation = false;
    bPrevPosBasedHeightOrientation = false;
    bPaintingHoleIntersection = false;

    //Material
    bAtlasTexture = false;
    bAtlasTextureSingleFrame = false;
    TexNameAlbedo: string | null = null;
    TexNameMask: string | null = null;
    TexNameNormal: string | null = null;
    TexNameRoughness: string | null = null;
    bSmokePath = false;
    bEnableBlend = true;
    bEmitter = false;
    Brightness = 1.0; //Alpha for Smoke
    Alpha = 1.0; //For alpha blend into SceneColor
    SmokeBrightness = 1.0;
    bCircle = false;
    bSimpleShading = false;

    //Mesh
    bUsesMesh = false;
    MeshFilePath: string | null = null;
}

export function GetWoodDebrisParticleDesc() {
    const desc = new ParticleDesc();
    desc.MaxNumInstances = 2500;
    desc.ParticleLifeTimeSec = 5.0;
    desc.NumParticlesPerSpawn = 25;
    desc.SizeScale = 0.3;
    desc.GravityForceScale = 0.75;
    desc.InitPosRandOffsetScale = 3.5;
    desc.RandVelScale = 1.5;
    desc.InitVelMin = 0.1;
    desc.RandHeightSizeMinMax = GetVec2(2.0, 5.0);
    desc.SizeRandMinMax = GetVec2(0.0, 0.8);

    desc.InitVelocityZScale = 1.0;

    desc.TexNameAlbedo = "woodDebrisDFS";
    desc.TexNameMask = "woodDebrisMask_R8";
    desc.bAtlasTexture = true;

    return desc;
}

export function GetFlashParticleDesc() {
    const desc = new ParticleDesc();
    desc.MaxNumInstances = 20;
    desc.ParticleLifeTimeSec = 0.05;
    desc.NumParticlesPerSpawn = 1;
    desc.SizeScale = 0.1;
    desc.GravityForceScale = 0.0;
    desc.InitPosRandOffsetScale = 0.0;
    desc.RandVelScale = 0.0;
    desc.InitVelMin = 0.05;
    desc.RandHeightSizeMinMax = GetVec2(1.0, 1.0);
    desc.SizeRandMinMax = GetVec2(1.0, 1.0);

    desc.EmitterTextureSpawnRange = GetVec2(-100.0, 100);

    desc.InitVelocityZScale = 1.1;

    desc.bEmitter = true;
    desc.Brightness = 10.0;

    desc.TexNameAlbedo = "orangeDFS";

    return desc;
}

export function GetSparksParticleDesc() {
    const desc = new ParticleDesc();
    const numparticles = 1000;
    desc.MaxNumInstances = numparticles;
    desc.ParticleLifeTimeSec = 5.0;
    desc.NumParticlesPerSpawn = numparticles;
    desc.SizeScale = 0.1;
    desc.GravityForceScale = 1.0;
    desc.InitPosRandOffsetScale = 3.5;
    desc.RandVelScale = 5.5;
    desc.InitVelMin = 1.5;
    desc.RandHeightSizeMinMax = GetVec2(2.0, 10.0);
    desc.SizeRandMinMax = GetVec2(0.1, 1.5);

    desc.EmitterTextureSpawnRange = GetVec2(-100.0, 100);

    desc.RotationSpeedScale = 4.5;

    /* desc.bUseCurlNoiseVelocity = true;
    desc.bInitVelocityDense = true; */

    //desc.bVelocityBasedRotation = true;
    desc.bPrevPosBasedHeightOrientation = true;
    desc.RotationSpeedScale = 0.0;

    desc.bEmitter = true;
    desc.Brightness = 5.0;

    desc.InitVelocityZScale = 0.5;

    desc.TexNameAlbedo = "whiteDFS";

    return desc;
}

export function GetPaintSparksParticleDesc() {
    const desc = new ParticleDesc();
    desc.MaxNumInstances = 2500;
    desc.ParticleLifeTimeSec = 0.2;
    desc.NumParticlesPerSpawn = 100;
    desc.SizeScale = 1.3;
    desc.GravityForceScale = 0.0;
    desc.InitPosRandOffsetScale = 0.15;
    desc.RandVelScale = 1.0;
    desc.InitVelMin = 1.5;
    desc.RandHeightSizeMinMax = GetVec2(1.0, 15.0);
    desc.SizeRandMinMax = GetVec2(0.1 * 0.2, 0.1 * 0.725);

    desc.EmitterTextureSpawnRange = GetVec2(-100.0, 100);

    desc.bUseCurlNoiseVelocity = true;
    desc.bInitVelocityDense = true;

    desc.bEmitter = true;
    desc.Brightness = 2.0;
    //desc.bCircle = true;

    desc.bVelocityBasedRotation = true;

    desc.InitVelocityZScale = 0.1;

    desc.RotationSpeedScale = 0.0;

    desc.TexNameAlbedo = "gradientDisp3";

    return desc;
}

export function GetPaintSparksParticleDesc2() {
    const desc = new ParticleDesc();
    desc.MaxNumInstances = 500;
    desc.ParticleLifeTimeSec = 1.2;
    desc.NumParticlesPerSpawn = 5;
    desc.SizeScale = 2.5 * 0.3;
    desc.GravityForceScale = 0.0;
    desc.InitPosRandOffsetScale = 0.15;
    desc.RandVelScale = 5.5 /* * 0.3 */;
    desc.InitVelMin = 2.5 /* * 5.0 */;
    desc.RandHeightSizeMinMax = GetVec2(1.0, 14.0);
    desc.SizeRandMinMax = GetVec2(0.1 * 0.1, 0.15);

    desc.EmitterTextureSpawnRange = GetVec2(-100.0, 100);

    desc.bUseCurlNoiseVelocity = true;
    //desc.bInitVelocityDense = true;

    desc.bEmitter = true;
    desc.Brightness = 2.0;
    desc.bCircle = false;

    desc.bVelocityBasedRotation = false;
    desc.bPrevPosBasedHeightOrientation = true;

    desc.InitVelocityZScale = 0.5;

    desc.RotationSpeedScale = 0.0;

    desc.TexNameAlbedo = "gradientDisp4";

    return desc;
}

export function GetWoodSmallChunkParticleDesc() {
    const desc = new ParticleDesc();
    desc.bProceduralCube = true;

    desc.EmitterTextureSpawnRange = GetVec2(0.0, 0.6);

    desc.RotationSpeedScale = 4.5;

    desc.InitVelMin = 1.5;
    desc.RandVelScale = 0.5;

    desc.InitVelHeightBoost = 1.0;

    desc.InitPosRandOffsetScale = 1.0;

    desc.SizeRandMinMax = GetVec2(0.25, 0.75);
    desc.SizeRandMinMax.x *= 0.75;
    desc.SizeRandMinMax.y *= 0.75;
    desc.RandHeightSizeMinMax = GetVec2(2.5, 5.0);

    desc.TexNameAlbedo = "woodTiles2DFS";
    desc.TexNameNormal = "woodRoughNRM";
    desc.TexNameRoughness = "woodRoughRGH_R8";
    return desc;
}

export function GetWoodMeshParticleDesc() {
    const desc = new ParticleDesc();
    desc.NumParticlesPerSpawn = 2;
    desc.RotationSpeedScale = 4.0;

    desc.EmitterTextureSpawnRange = GetVec2(0.0, 0.3);

    desc.SizeScale = 0.8;

    desc.InitVelMin = 1.5;
    desc.RandVelScale = 0.5;

    desc.InitVelHeightBoost = 1.0;

    desc.InitPosRandOffsetScale = 1.0;

    desc.InitVelocityZScale = 1.5;

    desc.SizeRandMinMax = GetVec2(0.7, 0.8);
    desc.SizeRandMinMax.x *= 2.0;
    desc.SizeRandMinMax.y *= 2.0;
    desc.RandHeightSizeMinMax = GetVec2(1.0, 2.0);

    desc.TexNameAlbedo = "woodTiles1DFS";
    desc.TexNameNormal = "woodRoughNRM";
    desc.TexNameRoughness = "woodRoughRGH_R8";

    desc.bUsesMesh = true;
    desc.MeshFilePath = Mesh.GMeshesLocationFolder + `woodDebris/mesh12.gltf`;

    return desc;
}

export function GetWoodMesh2ParticleDesc() {
    const desc = new ParticleDesc();
    desc.NumParticlesPerSpawn = 1;
    desc.MaxNumInstances = 10;
    desc.RotationSpeedScale = 5.5;

    desc.EmitterTextureSpawnRange = GetVec2(0.0, 0.3);

    desc.SizeScale = 1.0;

    desc.InitVelMin = 0.15;
    desc.RandVelScale = 1.0;

    desc.InitVelHeightBoost = 1.5;

    desc.InitPosRandOffsetScale = 1.0;

    desc.InitVelocityZScale = 1.5;

    desc.SizeRandMinMax = GetVec2(0.95, 0.8);
    desc.SizeRandMinMax.x *= 3.0 / 1.5;
    desc.SizeRandMinMax.y *= 3.0 / 1.5;
    desc.RandHeightSizeMinMax = GetVec2(0.7, 1.2 * 1.5);

    desc.TexNameAlbedo = "woodTiles2DFS";
    desc.TexNameNormal = "woodRoughNRM";
    desc.TexNameRoughness = "woodRoughRGH_R8";

    desc.bUsesMesh = true;
    desc.MeshFilePath = Mesh.GMeshesLocationFolder + `woodDebris/mesh2.gltf`;
    return desc;
}

export function GetDustParticleDesc() {
    const desc = new ParticleDesc();

    desc.bCircle = true;
    desc.Brightness = 1.0;
    desc.bUseCurlNoiseVelocity = true;

    desc.MaxNumInstances = 1500;
    desc.ParticleLifeTimeSec = 25.0;
    desc.NumParticlesPerSpawn = 20;
    desc.SizeScale = 1.06 * 0.5;
    desc.GravityForceScale = 0.01;
    desc.InitPosRandOffsetScale = 0.5;
    desc.RandVelScale = 0.5;
    desc.InitVelMin = 2.5;
    desc.RandHeightSizeMinMax = GetVec2(1.0, 1.0);
    desc.SizeRandMinMax = GetVec2(0.15, 0.25);

    desc.VelocityDampingAdd = 1.0;

    desc.Alpha = 0.5;

    desc.bSimpleShading = true;

    desc.InitVelocityZScale = 5.0;
    desc.InitVelHeightBoost = 0.0;

    desc.TexNameAlbedo = "whiteDFS";
    desc.bAtlasTexture = false;

    return desc;
}

export function GetSnowFastParticleDesc() {
    const desc = new ParticleDesc();

    desc.bSmokePath = true;
    desc.Brightness = 1.0;
    desc.bUseCurlNoiseVelocity = true;
    desc.bUseCurlNoiseVelocityLF = true;

    desc.bConstSpawnPos = true;
    desc.bForceSpawn = true;

    desc.bPaintingHoleIntersection = true;

    desc.bMoreCurlOnImpact = false;
    desc.CurlNoiseVelScale = 3.0;

    desc.ToCamWindForceScale = 30.0;
    desc.GravityForceScale = 0.4;

    //desc.bEnableBlend = false;

    desc.EmitterTextureSpawnRange = GetVec2(-100.0, 100);

    desc.MaxNumInstances = 3000;
    desc.ParticleLifeTimeSec = 30.0;
    desc.NumParticlesPerSpawn = 2;
    desc.SizeScale = 0.5 * 0.5 * 0.25;

    desc.InitPosRandOffsetScale = 1.0;
    desc.RandVelScale = 0.5;
    desc.InitVelMin = 0.0;
    desc.RandHeightSizeMinMax = GetVec2(1.0, 1.0);
    desc.SizeRandMinMax = GetVec2(0.15, 0.2);

    desc.InitVelocityZScale = 1.0;
    desc.InitVelHeightBoost = 0.0;

    desc.bEmitter = true;

    desc.TexNameAlbedo = "whiteDFS";
    desc.bAtlasTexture = false;

    return desc;
}

export function GetSnowParticleDesc() {
    const desc = new ParticleDesc();

    desc.bSmokePath = true;
    desc.Brightness = 1.0;
    desc.bUseCurlNoiseVelocity = true;
    desc.bUseCurlNoiseVelocityLF = true;

    desc.bPaintingHoleIntersection = true;

    desc.bConstSpawnPos = true;
    desc.bForceSpawn = true;

    desc.bMoreCurlOnImpact = false;
    desc.CurlNoiseVelScale = 4.0;

    desc.ToCamWindForceScale = 0.0;
    desc.GravityForceScale = 0.2;

    //desc.bEnableBlend = false;

    desc.EmitterTextureSpawnRange = GetVec2(-100.0, 100);

    desc.MaxNumInstances = 30000;
    desc.ParticleLifeTimeSec = 20.0;
    desc.NumParticlesPerSpawn = 20;
    desc.SizeScale = 0.5 * 0.75 * 0.35;

    desc.InitPosRandOffsetScale = 1.0;
    desc.RandVelScale = 0.5;
    desc.InitVelMin = 0.0;
    desc.RandHeightSizeMinMax = GetVec2(1.0, 1.0);
    desc.SizeRandMinMax = GetVec2(0.1, 0.2);

    desc.InitVelocityZScale = 1.0;
    desc.InitVelHeightBoost = 0.0;

    desc.bEmitter = true;

    desc.TexNameAlbedo = "whiteDFS";
    desc.bAtlasTexture = false;

    return desc;
}

export function GetSnowSmokeParticleDesc() {
    const desc = new ParticleDesc();

    desc.bSmokePath = true;
    desc.Brightness = 0.3;
    desc.SmokeBrightness = 0.2;
    desc.bUseCurlNoiseVelocity = false;
    desc.bUseCurlNoiseVelocityLF = true;

    desc.bConstSpawnPos = true;
    desc.bForceSpawn = true;

    desc.bPaintingHoleIntersection = false;

    desc.EmitterTextureSpawnRange = GetVec2(-100.0, 100);

    desc.MaxNumInstances = 50;
    desc.ParticleLifeTimeSec = 30.0;
    desc.SpawnTimeDelta = 0.3;

    desc.ToCamWindForceScale = 5.0;
    desc.GravityForceScale = 0.15;

    desc.NumParticlesPerSpawn = 1;
    desc.SizeScale = 5.5;
    desc.InitPosRandOffsetScale = 1.0;
    desc.RandVelScale = 0.5;
    desc.InitVelMin = 0.0;
    desc.RandHeightSizeMinMax = GetVec2(1.0, 1.0);
    desc.SizeRandMinMax = GetVec2(8.15, 10.2);

    desc.InitVelocityZScale = 1.0;
    desc.InitVelHeightBoost = 0.0;

    desc.bEmitter = true;
    //desc.Brightness = 2.0;

    desc.TexNameAlbedo = "Explosion01-nofire_5x5";
    desc.bAtlasTexture = true;
    desc.bAtlasTextureSingleFrame = true;

    return desc;
}

export function GetSmokeParticleDesc() {
    const desc = new ParticleDesc();

    desc.bSmokePath = true;
    desc.Brightness = 0.5;
    desc.SmokeBrightness = 0.8;
    desc.bUseCurlNoiseVelocity = false;

    desc.MaxNumInstances = 200;
    desc.ParticleLifeTimeSec = 12.0;
    desc.NumParticlesPerSpawn = 1;
    desc.SizeScale = 1.75;
    desc.GravityForceScale = 0.0;
    desc.InitPosRandOffsetScale = 0.5;
    desc.RandVelScale = 0.3;
    desc.InitVelMin = 2;
    desc.RandHeightSizeMinMax = GetVec2(1.0, 1.0);
    desc.SizeRandMinMax = GetVec2(0.8, 1.2);

    desc.RotationSpeedScale = 1.0;

    desc.VelocityDampingAdd = 3.0;

    desc.InitVelocityZScale = 5.0;
    desc.InitVelHeightBoost = 0.0;

    desc.TexNameAlbedo = "Explosion01-nofire_5x5";
    desc.bAtlasTexture = true;

    return desc;
}

export function GetPaintSmokeParticleDesc() {
    const desc = new ParticleDesc();

    desc.bSmokePath = true;
    desc.Brightness = 1.5;
    desc.bUseCurlNoiseVelocity = false;

    desc.MaxNumInstances = 200;
    desc.ParticleLifeTimeSec = 12.0;
    desc.NumParticlesPerSpawn = 1;
    desc.SizeScale = 1.15;
    desc.GravityForceScale = 0.0;
    desc.InitPosRandOffsetScale = 0.5;
    desc.RandVelScale = 0.75;
    desc.InitVelMin = 0.1 * 0.5;
    desc.RandHeightSizeMinMax = GetVec2(1.0, 1.0);
    desc.SizeRandMinMax = GetVec2(0.8, 1.2);

    desc.EmitterTextureSpawnRange = GetVec2(-100.0, 100);

    desc.RotationSpeedScale = 1.0;

    desc.VelocityDampingAdd = 3.0;

    desc.InitVelocityZScale = 5.0;
    desc.InitVelHeightBoost = 0.0;

    desc.TexNameAlbedo = "Explosion01-nofire_5x5";
    desc.bAtlasTexture = true;

    return desc;
}

export function GetImpactSmokeParticleDesc() {
    const desc = new ParticleDesc();

    desc.bSmokePath = true;
    desc.Brightness = 2.5;
    desc.bUseCurlNoiseVelocity = false;

    //desc.bConstSpawnPos = true;

    desc.MaxNumInstances = 46;
    desc.ParticleLifeTimeSec = 20.0;
    desc.NumParticlesPerSpawn = desc.MaxNumInstances;
    desc.SizeScale = 3.75;
    desc.GravityForceScale = 0.0;
    desc.InitPosRandOffsetScale = 0.5;
    desc.RandVelScale = 2.0;
    desc.InitVelMin = 2.5;
    desc.RandHeightSizeMinMax = GetVec2(1.0, 1.0);
    desc.SizeRandMinMax = GetVec2(0.8, 2.2);

    desc.EmitterTextureSpawnRange = GetVec2(-100.0, 100);

    desc.RotationSpeedScale = 2.0;

    desc.VelocityDampingAdd = 2.0;

    desc.InitVelocityZScale = 1.0;
    desc.InitVelHeightBoost = 0.0;

    desc.TexNameAlbedo = "Explosion01-nofire_5x5";
    desc.bAtlasTexture = true;

    return desc;
}

export function GetImpactSparksParticleDesc() {
    const desc = new ParticleDesc();
    desc.MaxNumInstances = 300;
    desc.ParticleLifeTimeSec = 10.2;
    desc.NumParticlesPerSpawn = desc.MaxNumInstances;

    desc.EmitterTextureSpawnRange = GetVec2(-100.0, 100);

    desc.bEmitter = true;
    desc.Brightness = 2.0;

    //desc.ToCamWindForceScale = 1.0;

    desc.InitVelocityZScale = 0.2;

    desc.TexNameAlbedo = "greenDFS";

    ////////////////////////////////
    desc.bProceduralCube = true;

    desc.bUseCurlNoiseVelocity = true;
    desc.bUseCurlNoiseVelocityLF = true;

    desc.RotationSpeedScale = 4.5;

    desc.InitVelMin = 0.5;
    desc.RandVelScale = 1.5;

    desc.CurlNoiseVelScale = 1.5;

    desc.InitVelHeightBoost = 0.0;

    desc.InitPosRandOffsetScale = 3.0;

    desc.SizeScale = 0.5;
    desc.SizeRandMinMax = GetVec2(0.1, 1.0);
    desc.RandHeightSizeMinMax = GetVec2(1.0, 1.5);

    desc.GravityForceScale = 0.2;

    return desc;
}
